import React from "react";
import Loader from "../../../../components/Loader";
import {  Container, Stack, Button, Typography } from "@mui/material";
import { toast, ToastContainer } from 'react-toastify';
import Page from "../../../../components/Page";
import HTTPManager from "../../../../utils/httpRequestManager";
import MerchantDataGrid from '../DataGrid';  
import FormManager from "../../../../components/formComponents/FormManager";
import { checkButtonAccess } from "../../../../utils/protector";

export default class RejectedMerchants extends React.Component{
    httpManager = new HTTPManager();

    constructor(){
        super();
        this.state={
            isLoading:false,
            userdetail:{},
            merchantsList  :[],
            selectedMerchant:{},
            viewMerchant: false,
            columns:[ 
                  {
                    field: 'merchantName',
                    headerName: 'Business',
                    minWidth: 100, flex: 1,
                    editable: false,
                    renderCell: (params) => (
                      <div className="twoLineText" title={params.row.merchantName}>
                          {params.row.merchantName}
                      </div>
                    )
                  }, 
                  {
                    field: 'merchantEmail',
                    headerName: 'Email',
                    minWidth: 200, flex: 1,
                    editable: false,
                    renderCell: (params) => (
                      <div>
                          {params.row.merchantEmail}
                      </div>
                    )
                  },
                  {
                    field: 'merchantPhone',
                    headerName: 'Mobile',
                    minWidth: 150, flex: 1,
                    editable: false,
                    renderCell: (params) => (
                      <div>
                          {params.row.merchantPhone}
                      </div>
                    )
                  }, 
                  {
                    field: 'ownerName',
                    headerName: 'Owner Name',
                    minWidth:100, flex: 1,
                    editable: false,
                    renderCell: (params) => (
                      <div className="twoLineText" title={params.row.ownerName === '' || params.row.ownerName === null ? '--' : params.row.ownerName}>
                        {params.row.ownerName === '' || params.row.ownerName === null ? '--' : params.row.ownerName}
                      </div>
                    )
                  } ,
                  {
                    field:'',
                    headerName:'Actions',
                    maxWidth:250,
                    minWidth:250, flex: 1,
                    editable: false,
                    renderCell: (params)=>(
                        <div> 
                           
                            {( this.state.userdetail.userRole === 'SuperAdmin' || this.state.userdetail.userRole === 'Admin') &&<div > 
                                            <Button variant="contained" onClick={()=>{
                                                this.viewDetail(params.row)
                                            }}>View</Button>  
                                            </div>
                            }  

                        </div>
                    )
                  }
            ], 
        } 
        this.viewDetail = this.viewDetail.bind(this);
        this.setFormDetails = this.setFormDetails.bind(this);
    }
    viewDetail(detail){
        this.setState({selectedMerchant: detail}, ()=>{
            this.setFormDetails()
        })
    }

    setFormDetails(){
      this.setState({isLoading: true})
      var data = Object.assign({}, this.state.selectedMerchant);
      var schema = Object.assign({}, this.state.schema);
      var propslist = Object.assign([], this.state.schema.properties);
      var properties = [];
      propslist.forEach((field, i)=>{ 
          field.value = data[field.name];
          // field.disabled=true;
          properties.push(field);
          if(i === propslist.length-1){ 
              properties.push({
                  "component":"TextField", 
                  "type": "hidden", 
                  "minLength": 1,
                  "maxLength": 50,
                  "grid":6,
                  "name":"id",
                  "label":"id",
                  "placeholder":"id",
                  "value":data.id
                })
              //console.log(properties)
              schema.properties = properties
              this.setState({schema: schema},()=>{
                  this.setState({isLoading: false, viewMerchant: true})
              })
          }
      })
  }
    componentDidMount(){
        var details  = window.localStorage.getItem('userdetail');
        if(details !== undefined && details !== null && details !== ''){
            this.setState({userdetail: JSON.parse(details)}, ()=>{
                this.reloadData();
            })
        } 
    }

    reloadData(msg=''){
        if(msg !== ''){
            toast.dismiss();
            toast.success(msg, {
                position: "top-center",
                autoClose: 5000,
                closeButton:false,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }

        this.setState({isLoading: true}, ()=>{
            this.httpManager.postRequest(`merchant/getRejectedMerchants`,{rights:checkButtonAccess('Merchant.Rejected')}).then(response=>{
               this.setState({merchantsList: response.data, isLoading:false});
            })

        })
    }   

    render(){
        return  <Page title="Rejected Merchant | Astro POS">
          {this.state.isLoading && <Loader />}
          <ToastContainer 
            position="top-center"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
            />  
        <Container maxWidth="xl">
        {!this.state.viewMerchant && <><Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Rejected Merchants
            </Typography> 
            </Stack>
            <MerchantDataGrid columns={this.state.columns} data={this.state.merchantsList} showAssignee={false}  assignees={[]}/>
                        </>} 
        {this.state.viewMerchant && <FormManager formProps={this.state.schema} reloadData={()=>{
                this.reloadData()
            }} closeForm={(action='', formData={})=>{
                //console.log(action, formData)
                if(action === ''){
                    this.setState({viewMerchant: false, selectedMerchant: {}})
                }
                if(action==='Deactivate'){
                    this.onDeactivate();
                } 
            }}/>}
            </Container>
        </Page>
    }
}